import { render } from "./OptionboardPhoneticConsonant.vue?vue&type=template&id=341d51c6&scoped=true"
import script from "./OptionboardPhoneticConsonant.vue?vue&type=script&lang=js"
export * from "./OptionboardPhoneticConsonant.vue?vue&type=script&lang=js"

import "@/css/components/optionboard-phonetic-consonant.css?vue&type=style&index=0&id=341d51c6&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341d51c6"]])

export default __exports__